<template>
  <div style="width: 100%; height: 100%">
    <GmapMap
      :center="mapCenter"
      :zoom="zoom"
      :style="{ width: '100%', height: '100%' }"
      :options="{ styles: mapStyles, disableDefaultUI }"
      ref="map"
      id="map"
      class="elevation-3">
      <GmapMarker
        v-for="(point, index) in points"
        :key="index"
        :position="{lat: Number(point.lat), lng: Number(point.long)}"
        :clickable="true"
        :draggable="false"
        :icon="{
          path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
          fillColor: getColor(point.color),
          labelOrigin: { x: 0, y: 35 },
          fillOpacity: pointOpacity,
          anchor: { x:0, y: 0 },
          strokeWeight: pointStroke,
          scale: scale
        }"
        :label="labels ? { text: point.denumire, color: labelcolor ? getColor(point.color) : '#000', fontWeight: 'bold', fontSize: `${labelSize}px` } : ''">
      </GmapMarker>
    </GmapMap>

    <div class="map-title display-4 font-weight-bold" :style="{'font-size': `${112 * legendScale}px !important`}">
      ({{ total }}) {{ title }}
    </div>
    <div class="map-legend display-4 font-weight-bold pl-5" :style="{'transform': `scale(${legendScale})`}">
      <table>
        <tr v-for="(color, index) in colors" :key="color" class="legend-item">
          <td>
            <span class="legend-bullet mr-4" :style="{ 'background-color': color}"></span>
          </td>
          <td class="legend-count blue-grey--text pr-4">
            {{ legendCount[index] }}
          </td>
          <td class="legend-label display-4">
            {{ legendLabels[index] }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapStyles } from '@/constants/mapStyles'

export default {
  name: 'print-map',
  data: () => ({
    points: null,
    mapCenter: {
      lat: 46.03308197722126,
      lng: 24.905333289473706
    },
    zoom: 7.25,
    scale: 0.1,
    disableDefaultUI: true,
    labels: false,
    labelSize: 8,
    labelcolor: false,
    sheet: null,
    pointOpacity: 0.6,
    pointStroke: 0,
    colors: null,
    legendCount: null,
    legendLabels: null,
    title: null,
    total: 0,
    legendScale: 1
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    mapStyles () {
      return [ ...mapStyles ]
    }
  },
  methods: {
    getColor (value) {
      if (!isNaN(value)) {
        switch (value) {
          case 1: return this.colors[value] // '#F0C300'
          case 2: return this.colors[value] // '#E67E30'
          case 3: return this.colors[value] // '#7FDD4C'
        }
      } else {
        return value
      }
    }
  },
  mounted () {
    // http://localhost:8080/#/printmap/5e987a5220f06a7618e7b33c/9/0.5/0/8/0/0.6/0/Tara/1/eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJ1c2VySWQiOiI1Y2QxOTA3MDMwMzhiYzA2NTI2MGQ0ZWMiLCJpYXQiOjE1ODc0MTUzNzMsImV4cCI6MTU4NzUwMTc3MywiYXVkIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwLyMvIiwiaXNzIjoiZmVhdGhlcnMiLCJzdWIiOiJhbm9ueW1vdXMiLCJqdGkiOiJhN2M2YmUzMy01MzFiLTQ2NjItOTM5NC03NjQyOTdjMzJhNzIifQ.QbPgjPVCqciH4lMgf_DHT_6uW00EWFocz0sCO6qrX3Y
    this.zoom = +this.$route.params.zoom
    this.scale = +this.$route.params.scale
    this.labels = +this.$route.params.labels
    this.labelSize = +this.$route.params.labelsize
    this.labelcolor = +this.$route.params.labelcolor

    this.legendScale = +this.$route.params.legendScale

    this.sheet = this.$route.params.sheet
    this.pointOpacity = +this.$route.params.pointOpacity
    this.pointStroke = +this.$route.params.pointStroke
    fetch(`${this.host}/adminmaps/${this.$route.params.id}`, {
      // credentials: 'same-origin',
      method: 'get',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': this.$route.params.token
      })
    })
      .then(res => res.json())
      .then(res => {
        console.log(res)
        this.points = res.data[this.sheet]
        this.colors = res.colors[this.sheet]
        this.legendCount = res.legendCount[this.sheet]
        this.legendLabels = res.legendLabels[this.sheet]
        this.title = res.title[this.sheet]

        this.total = Object.keys(this.legendCount).reduce((acc, key) => (acc += this.legendCount[key]), 0)
      })
  }
}
</script>

<style lang="stylus">
.map-legend {
  transform-origin: bottom left;
  position: absolute;
  bottom: 0;
  left: -4px;
  min-width: 800px;
  height: 400px;
  border: 4px solid #3e7fc2;
  font-size: 32px;
  color: #3e7fc2;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

// .legend-item {
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
// }

.legend-item td {
  vertical-align: middle;
}

.legend-bullet {
  display: inline-block;
  border-radius: 100%;
  width: 100px;
  height: 100px;
}

.legend-count {
  font-size: 52px;
}

.legend-label {
  font-size: 52px !important;
}

.map-title {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 64px;
  color: #3e7fc2;
}
</style>
